import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import useFetch from "../server/useFetch";
// import { useTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import logger from "../server/server";
import { MIDDLEWARE } from "../utils/config/configs";
import { useAuthContext } from "./AuthContext";
import { getLevelsByPriority } from "../utils/hooks/getLevelsByPriority";
import { set } from "react-hook-form";

const GlobalFilterContext = createContext(null);

export const useGlobalFilterContext = () => {
  const context = useContext(GlobalFilterContext);

  if (!context) {
    throw new Error(
      "useGlobalFilterContext must be used within an ContentProvider"
    );
  }
  return context;
};

export const GlobalFilterProvider = (props) => {
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const [isToApplyFilters, setIsToApplyFilters] = useState(false); //Triggers certain components to apply filters
  const [dropdownEntity, setDropdownEntity] = useState(null); //Dropdown options
  const [entity, setEntity] = useState(null); //Dropdown value
  const [dropdownSubEntity, setDropdownSubEntity] = useState(null); //Dropdown options
  const [subEntity, setSubEntity] = useState(null); //Dropdown value
  // const [copySubEntity, setCopySubEntity] = useState(null);
  const [dataRegions, setDataRegions] = useState(null); //Dropdown value
  // const [itemAll, setItemAll] = useState(null);

  const [mapPois, setMapPois] = useState(null);
  const [copyMapPois, setCopyMapPois] = useState(null);
  const [dropdownClasses, setDropdownClasses] = useState([]);
  const [classes, setClasses] = useState(null);
  const [dropdownPriorities, setDropdownPriorities] = useState([]);
  const [prioritiesSelected, setPrioritiesSelected] = useState(null);
  const [dropdownImpactedFA, setDropdownImpactedFA] = useState([]);
  const [impactedFASelected, setImpactedFASelected] = useState(null);
  const [dropdownFAOwner, setDropdownFAOwner] = useState([]);
  const [faOwnerSelected, setFAOwnerSelected] = useState(null);

  // Ref para armazenar os valores anteriores
  // const prevValues = useRef({
  //   classes: classes,
  //   prioritiesSelected: prioritiesSelected,
  //   impactedFASelected: impactedFASelected,
  //   faOwnerSelected: faOwnerSelected
  // });

  const [selectedLayer, setSelectedLayer] = useState('Incidents');//Define o layer a apresentar no mapa

  const { data: dataRegionsDropdown, refetch: refetchRegionsDropdown, isFetching: dataRegionsIsFetching } = useFetch("/map/regions", "regionDropdown",
    {
      tenant: tenant,
    }, null, null, MIDDLEWARE);

  const { data: mapItemsIncidentsData, isFetching: isFetchingMapIncidentsData, refetch: refetchMapItemsIncidents } = useFetch(
    'incidents/map/items', 'getMapItemsIncidents',
    {
      id: "c940f129-7136-495b-9402-348419b1d013",
      // layer: "INCIDENTS",
      tenant: "NOVA - Campus de Campolide"
    },
    null, null, 'https://middleware.command.dttsynergy.com/api');

  // const { data: mapItemsServicesData, isFetching: isFetchingMapServicesData, refetch: refetchMapItemsServices } = useFetch(
  //   '/map/items', 'getMapItemsServices',
  //   {
  //     id: subEntity ? subEntity?.id : entity?.id,
  //     layer: "City Service",
  //     tenant: subEntity ? subEntity?.tenant : entity?.tenant
  //   },
  //   subEntity ? true : entity ? true : false, null, 'https://middleware.dev-dttsynergy.com/api');

  useEffect(() => {
    if (subEntity) {
      refetchMapItemsIncidents();
    }
  }, [subEntity]);

  // useEffect(() => {
  //   // Função auxiliar para verificar se uma dependência mudou
  //   const hasChanged = (prev, next) => JSON.stringify(prev) !== JSON.stringify(next);

  //   var filteredData;
  //   if (hasChanged(prevValues.current.classes, classes)) {
  //     filteredData = mapPois?.filter(item => classes.map(x => x.value).includes(item.class)) ?? [];
  //     setCopyMapPois(filteredData);
  //     prevValues.current.classes = classes;
  //   };
  //   if (hasChanged(prevValues.current.prioritiesSelected, prioritiesSelected)) {
  //     filteredData = mapPois?.filter(item => prioritiesSelected.map(x => x.value).includes(item.priority)) ?? [];
  //     setCopyMapPois(filteredData);
  //     prevValues.current.prioritiesSelected = prioritiesSelected;
  //   };
  //   if (hasChanged(prevValues.current.impactedFASelected, impactedFASelected)) {
  //     filteredData = mapPois?.filter(item => {
  //       if(impactedFASelected.some(selected => item.impactedFA.split(', ').includes(selected.value))){
  //         return item;
  //       }
  //       if(impactedFASelected.some(selected => selected.value === 'N/A') && item.impactedFA === ""){
  //         return item;
  //       }
  //     }) ?? [];
  //     setCopyMapPois(filteredData);
  //     prevValues.current.impactedFASelected = impactedFASelected;
  //   };
  //   if (hasChanged(prevValues.current.faOwnerSelected, faOwnerSelected)) {
  //     filteredData = mapPois?.filter(item => faOwnerSelected.map(x => x.value).includes(item.issueOwnerGroup)) ?? [];
  //     setCopyMapPois(filteredData);
  //     prevValues.current.faOwnerSelected = faOwnerSelected;
  //   };

  //   console.log('filteredData', filteredData);
  // }, [classes, prioritiesSelected, impactedFASelected, faOwnerSelected]);

  useEffect(() => {
    if (tenant) {
      refetchRegionsDropdown();
    }
  }, [tenant])

  useEffect(() => {
    setDataRegions(dataRegionsDropdown);
  }, [dataRegionsDropdown]);

  useEffect(() => {
    if (dataRegions) {
      const filterObj = {};

      const dropdownCountriesObject = selectSerialize(dataRegions);
      setDropdownEntity(dropdownCountriesObject);
      setEntity(dropdownCountriesObject[0]);
      filterObj.entity = dropdownCountriesObject[0];

      if (dropdownCountriesObject[0]?.cities) {
        const dropdownSubEntityArray = selectSerialize(
          dropdownCountriesObject[0]?.cities
        );
        const allItem = {//Criado para vermos o conjunto de todos os CLusters (Zonas)
          value: 'All Clusters',
          label: t('All Clusters'),
          id: dropdownCountriesObject[0]?.id,
          tenant: tenant,
          latitude: "45.7817252",
          longitude: "9.6885903",
          zoom: 8,
        };
        const newCitiesArray = [allItem, ...dropdownSubEntityArray];

        setDropdownSubEntity(newCitiesArray);
        setSubEntity(newCitiesArray[0]);
        filterObj.subEntity = newCitiesArray[0];
      }

      // setIsToApplyFilters(true);

      if (Object.keys(dataRegions).length === 0) {
        logger.warn("User: " + user?.Username + " Tenant: " + tenant + ", dataRegions is a empty object!");
      }
    }
  }, [dataRegions]);

  useEffect(() => {
    if (mapItemsIncidentsData) {
      const data = mapItemsIncidentsData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0"
        && !item.family?.includes('Facilities') && item.class);
      setMapPois(data);
      setCopyMapPois(data);

      // //Classes
      // const poiClasses = data?.map((x) => {
      //   return { label: x.class, value: x.class };
      // });
      // const uniqueClassesArray = poiClasses?.filter((item, index, self) =>
      //   index === self.findIndex((t) => t.value === item.value)
      // );//Limpar duplicados
      // setClasses(uniqueClassesArray);
      // setDropdownClasses(uniqueClassesArray);

      // // if (selectedLayer === 'Incidents') {
      // //Severity
      // const incidentsLevels = data?.map((x) => {
      //   return { label: getLevelsByPriority(x.priority), value: x.priority };
      // });
      // const uniqueIncidentsLevels = incidentsLevels?.filter((item, index, self) =>
      //   index === self.findIndex((t) => t.value === item.value)
      // );//Limpar duplicados
      // setPrioritiesSelected(uniqueIncidentsLevels);
      // setDropdownPriorities(uniqueIncidentsLevels);

      // //Impacted FA
      // const impactedFAArray = [];
      // data?.map((x) => {
      //   if (typeof x.impactedFA === 'string') {
      //     const values = x.impactedFA.split(', ');
      //     values.forEach((value) => {
      //       impactedFAArray.push(value);
      //     });
      //   }
      // })
      // const uniqueImpactedFAArray = impactedFAArray?.filter((item, index, self) =>
      //   index === self.findIndex((t) => t === item)
      // ).map(x => {
      //   if (x === '') return { label: 'N/A', value: 'N/A' }
      //   return { label: x, value: x }
      // }); // Remove duplicates
      // setImpactedFASelected(uniqueImpactedFAArray);
      // setDropdownImpactedFA(uniqueImpactedFAArray);

      // //FA Owner
      // const faOwners = data?.map((x) => {
      //   return { label: x.issueOwnerGroup, value: x.issueOwnerGroup };
      // });
      // const uniqueFAOwners = faOwners?.filter((item, index, self) =>
      //   index === self.findIndex((t) => t.value === item.value)
      // );//Limpar duplicados
      // setFAOwnerSelected(uniqueFAOwners);
      // setDropdownFAOwner(uniqueFAOwners);
      // // };

      // // Atualiza os valores anteriores no useRef
      // prevValues.current = {
      //   classes: uniqueClassesArray,
      //   prioritiesSelected: uniqueIncidentsLevels,
      //   impactedFASelected: uniqueImpactedFAArray,
      //   faOwnerSelected: uniqueFAOwners
      // };
      // console.log('data ', data);
      // console.log('prevValues', prevValues.current);
    };
  }, [mapItemsIncidentsData]);

  // useEffect(() => {
  //   if (!isToApplyFilters && subEntity && entity) {
  //     if (selectedLayer === 'Incidents') {
  //       const data = mapItemsIncidentsData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0" && item.priority !== '5 - Low');
  //       setMapPois(data);
  //       setCopyMapPois(data);
  //     } else {
  //       setViewType('map');
  //       const data = mapItemsServicesData?.filter(item => item.latitude && item.latitude !== "0" && item.longitude && item.longitude !== "0");
  //       setMapPois(data);
  //       setCopyMapPois(data);
  //     }
  //   }
  // }, [selectedLayer])

  const selectEntity = (value) => {
    if (value?.value) {
      const cities = dataRegions?.find((x) => {
        const name = x.name.split(".");
        if (name[0] === value.value) {
          return x;
        }
      })?.cities;

      if (cities) {
        const dropdownSubEntityObject = selectSerialize(cities);
        setDropdownSubEntity(dropdownSubEntityObject);
        setSubEntity(dropdownSubEntityObject[0]);
      } else {
        setDropdownSubEntity(null);
        setSubEntity(null);
      }
      setEntity(value);
    }
  };

  const value = useMemo(() => {
    return {
      isToApplyFilters,
      setIsToApplyFilters,

      dropdownEntity,
      entity,
      selectEntity,

      dropdownSubEntity,
      subEntity,
      setSubEntity,

      dataRegionsIsFetching,

      dropdownClasses,
      setDropdownClasses,
      classes,
      setClasses,
      dropdownPriorities,
      setDropdownPriorities,
      prioritiesSelected,
      setPrioritiesSelected,
      dropdownImpactedFA,
      impactedFASelected,
      setImpactedFASelected,
      dropdownFAOwner,
      faOwnerSelected,
      setFAOwnerSelected,

      selectedLayer,
      setSelectedLayer,

      mapPois,
      copyMapPois,
      setCopyMapPois,

      mapItemsIncidentsData,
      isFetchingMapIncidentsData,
      refetchMapItemsIncidents,

      // mapItemsServicesData,
      // isFetchingMapServicesData,
      // refetchMapItemsServices,
    };
  }, [entity, subEntity, isToApplyFilters, dataRegionsIsFetching, mapItemsIncidentsData, isFetchingMapIncidentsData,
    // mapItemsServicesData, isFetchingMapServicesData, 
    dropdownClasses, classes, dropdownPriorities, prioritiesSelected,
    dropdownImpactedFA, impactedFASelected, copyMapPois]);

  return (
    <GlobalFilterContext.Provider value={value}>
      {props.children}
    </GlobalFilterContext.Provider>
  );
};

const selectSerialize = (array) => {
  return array?.sort((a, b) => b.buIndex - a.buIndex)?.map((x) => {
    const name = x.name.split(".");
    return {
      value: name[0],
      label: name[0],
      id: x.id,
      tenant: x.tenant,
      cities: x.cities,
      latitude: x.latitude,
      longitude: x.longitude,
      zoom: x.zoom,
    };
  });
};